import React from "react";
import PropTypes from "prop-types";

export const CenteredDiv = ({ children }) => {
  return (
    <div className="my-2 centered">
      {children}
    </div>
  )
};

CenteredDiv.propTypes = {
  children: PropTypes.node.isRequired,
};
